export function contractDisabledDates() {
  return {
    computed: {
      startDateDisabledDates(this: { form: { endDate: Date } }) {
        const contractEndDate = this.form.endDate;
        const cannotStartAfter = contractEndDate;

        return { from: cannotStartAfter };
      },
      endDateDisabledDates(this: { form: { startDate: Date } }) {
        const contractStartDate = this.form.startDate;
        const cannotEndBefore = contractStartDate;

        return { to: cannotEndBefore };
      },
    },
  };
}
